export default {"src":"/login-app/[GIT_HASH]/_next/static/media/info_filled.f8ee8477.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};